<template>
	<BaseCmsPage>
		<WebshopCheckoutLayout>
			<template #header>
				<WebshopCheckoutHeader :step="5" />
			</template>
			<template #wcCol2>
				<BaseWebshopCheckout v-slot="{urls}">
					<WebshopStep :step="1" :completed="true" />
					<WebshopStep :step="2" :completed="true" />
					<WebshopStep :step="3" :completed="true" />
					<div class="step-form-cnt step-form4-cnt">
						<div class="step-form-cnt-inner">
							<WebshopStep :step="4" :title="true" />
							<ClientOnly>
								<BaseWebshopReviewOrderForm class="review-order-form" v-slot="{fields, customer, total, shipping, shippingLocation, payment, meta, loading, orderErrors}">
									
									<div class="customer-details">
										<div class="customer-detail customer-detail-info" v-if="customer">
											<div class="customer-detail-title">
												<BaseCmsLabel code="step1" /><NuxtLink :to="urls.webshop_customer"><BaseCmsLabel code="edit2" tag="span" class="edit" /></NuxtLink>
											</div>
											<div>
												<p>{{ customer.first_name }} {{ customer.last_name }}</p>
												<p>{{ customer.address.street }}, {{ customer.address.zipcode }} {{ customer.address.city }}<span v-if="customer?.address?.country_name">, {{ customer.address.country_name }}</span></p>
												<p v-if="customer?.phone || customer?.email">{{ customer.phone }}, {{ customer.email }}</p>
												<div class="global-error" v-if="orderErrors?.customer"><BaseCmsLabel :code="orderErrors.customer" /></div>
											</div>
										</div>

										<div class="customer-detail customer-detail-shipping" v-if="customer">
											<div class="customer-detail-title">
												<BaseCmsLabel code="shipping_details" /> <NuxtLink :to="urls.webshop_customer"><BaseCmsLabel code="edit2" tag="span" class="edit" /></NuxtLink>
											</div>
											<div v-if="customer?.b_first_name">
												<p>{{ customer.b_first_name }} {{ customer.b_last_name }}</p>
												<p>
													{{ customer.b_address.b_street }}, {{ customer.b_address.b_zipcode }} {{ customer.b_address.b_city }}<span v-if="customer?.b_address?.b_country_name">, {{ customer.b_address.b_country_name }}</span>
												</p>
												<p v-if="customer?.b_phone">{{ customer.b_phone }}</p>
											</div>
											<div v-else>
												<BaseCmsLabel code="same_as_shipping" tag="p" />
											</div>
										</div>

										<div class="customer-detail customer-detail-b" v-if="customer?.b_company_oib">
											<div class="customer-detail-title">
												<BaseCmsLabel code="b_r1" /> <NuxtLink :to="urls.webshop_customer"><BaseCmsLabel code="edit2" tag="span" class="edit" /></NuxtLink>
											</div>
											<div v-if="customer?.b_company_oib">
												<p v-if="customer?.b_company_name">{{ customer.b_company_name }}</p>
												<p v-if="customer?.b_company_address">{{ customer.b_company_address }}</p>
												<p v-if="customer?.b_company_zipcode || customer?.b_company_city">{{ customer.b_company_zipcode }} {{ customer.b_company_city }}</p>
												<p v-if="customer?.b_company_oib">{{ customer.b_company_oib }}</p>
											</div>
										</div>

										<div class="customer-detail customer-detail-delivery">
											<div class="customer-detail-title">
												<BaseCmsLabel code="shipping" /> <NuxtLink :to="urls.webshop_shipping"><BaseCmsLabel code="edit2" tag="span" class="edit" /></NuxtLink>
											</div>
											<p>
												{{ shipping?.title }}
												<span v-if="shipping?.pickup_location">
													<strong>({{shipping.pickup_location.title}})</strong></span
												>
											</p>
											<div class="personal-pickup-content" v-if="shippingLocation">
												<div class="title address" v-if="shippingLocation.address" v-html="shippingLocation.address" />
												<div class="title business-hour" v-if="shippingLocation.business_hour" v-html="shippingLocation.business_hour" />
												<div class="title contact" v-if="shippingLocation.contact" v-html="shippingLocation.contact" />
											</div>
											<div v-if="shipping?.description" v-html="shipping.description" class="personal-pickup-description" />

											<div class="global-error" v-if="orderErrors?.shipping"><BaseCmsLabel :code="orderErrors.shipping" /></div>
										</div>

										<div class="customer-detail customer-detail-payment">
											<div class="customer-detail-title">
												<BaseCmsLabel code="payment" /> <NuxtLink :to="urls.webshop_payment"><BaseCmsLabel code="edit2" tag="span" class="edit" /></NuxtLink>
											</div>
											<p>{{ payment?.title }}</p>
											<div class="global-error" v-if="orderErrors?.payment"><BaseCmsLabel :code="orderErrors.payment" /></div>
										</div>

										<div class="customer-detail customer-detail-total" v-if="total">
											<BaseCmsLabel code="total_to_pay3" tag="div" class="customer-detail-title" />
											<p><BaseUtilsFormatCurrency :price="total.total" /></p>
										</div>
									</div>

									<template v-if="fields">
										<BaseCmsPage :fetch="{slug: 'uvjeti-kupnje'}" v-slot="{page}">
											<div class="terms-container" v-if="page?.content">
												<div class="terms" v-html="page.content" />
												<div class="newwindow">
													<NuxtLink :to="page.url_without_domain" target="_blank"><BaseCmsLabel code="accept_terms_new_window" /></NuxtLink>
												</div>
											</div>
										</BaseCmsPage>

										<div class="alert" v-show="acceptTermsAlert"><BaseCmsLabel code="webshop_alert_terms" /></div>
										<div class="accept-terms-container" v-interpolation>
											<div v-for="field in fields" :key="field.name">
												<BaseFormField :item="field" v-slot="{errorMessage}">
													<BaseFormInput @click="checkAlert" />
													<BaseCmsLabel tag="label" :for="field.name" :code="'webshop_'+field.name" />
													<span class="error" v-show="errorMessage" v-html="errorMessage" />
												</BaseFormField>
											</div>
										</div>
									</template>

									<button class="btn btn-orange finish-order" :class="[{'accepted': !acceptTermsAlert},{'loading': loading}]" type="submit" :disabled="!meta.valid || loading" v-if="!orderErrors">
										<UiLoader v-if="loading" />
										<BaseCmsLabel code="finish_shopping2" />
									</button>
								</BaseWebshopReviewOrderForm>
							</ClientOnly>
						</div>
					</div>
				</BaseWebshopCheckout>
			</template>
		</WebshopCheckoutLayout>
	</BaseCmsPage>
</template>

<script setup>
	const acceptTerms = ref(false);
	const acceptTerms2 = ref(false);
	const finishOrderBtn = ref(false);
	function checkAlert(e) {
		if (e.target.name == 'accept_terms') acceptTerms.value = e.target.checked;
		if (e.target.name == 'accept_terms_2') acceptTerms2.value = e.target.checked;
	}

	// show/hide alert
	const acceptTermsAlert = computed(() => {
		return acceptTerms.value && acceptTerms2.value ? false : true;
	});

	// show/hide alert on page load
	onMounted(() => {
		const acceptTermsCheckbox = document.querySelector('[name="accept_terms"]');
		if (acceptTermsCheckbox) acceptTerms.value = acceptTermsCheckbox?.checked;

		const acceptTerms2Checkbox = document.querySelector('[name="accept_terms_2"]');
		if (acceptTerms2Checkbox) acceptTerms2.value = acceptTerms2Checkbox?.checked;
	});
</script>

<style lang="less" scoped>
	.step-form4-cnt{
		margin-top: 21px;
		@media (max-width: @t){margin-top: 14px;}	
	}
	.customer-details{display: flex; flex-flow: column; width: 100%; margin-bottom: 16px;}
	.customer-detail{
		position: relative; display: flex; flex-flow: column; border: 1px solid var(--gray); margin-top: -1px; padding: 20px 24px; font-size: 14px; line-height: 1.6;
		&:first-child{border-radius: 6px 6px 0 0;}
		&:last-child{border-radius: 0 0 6px 6px;}
		:deep(p){padding-bottom: 0;}
	}
	.customer-detail-title{
		position: relative; display: flex; align-items: center; font-size: 14px; line-height: 1.43; font-weight: 700; justify-content: space-between; gap: 2px; margin-bottom: 2px;
		a{
			font-size: 12px; font-weight: normal; color: var(--blue); text-decoration: underline; .transition(text-decoration-color);
			@media (min-width: @h){
				&:hover{text-decoration-color: transparent;}
			}
		}
	}
	.personal-pickup-description{padding-top: 2px;}

	.alert{
		position: relative; display: flex; background: var(--blue); color: #fff; border-radius: 4px; font-size: 12px; line-height: 1.4; font-weight: 700; padding: 13px 40px 11px; margin-bottom: 19px;
		&:before{.pseudo(16px,16px); .icon-info2(); font: 16px/1 var(--fonti); color: #fff; top: 12px; left: 16px;}
		&:after{.pseudo(8px,8px); background: var(--blue); .rotate(45deg); bottom: -3px; left: 6px;}
		@media (max-width: @t){
			font-size: 10px;
			&:before{top: 10px;}	
		}
	}
	.accept-terms-container{
		display: flex; flex-flow: column; gap: 10px;
		label{padding-bottom: 0;}
		.error{padding-left: 34px;}
		:deep(a){color: var(--blue);}
	}
	.finish-order{
		padding-left: 32px; padding-right: 32px; margin-top: 22px;
		&.loading{color: #fff!important;}
	}

	.terms-container{
		position: relative; display: block; margin-top: 15px;
	}
	.terms{
		display: block; font-size: 10px; line-height: 1.2; border: 1px solid var(--gray); border-radius: 6px; padding: 15px 20px; max-height: 90px; overflow-y: auto;
		&::-webkit-scrollbar {-webkit-appearance: none; width: 5px; border: 1px solid var(--gray); border-radius: 0 6px 6px 0; border-top: 0; border-right: 0; border-bottom: 0;}
		&::-webkit-scrollbar-thumb {background-color: var(--blue); border-radius: 6px;}
		h2{font-size: 24px;}
		h3{font-size: 20px;}
		h4{font-size: 16px;}
		:deep(.image-wrapper){margin: 12px 0 20px; gap: 8px;}
		:deep(.extra-images){gap: 8px; margin: 0 0 25px; flex-flow: column;}
		:deep(.extra){font-size: 14px; padding: 15px 20px; margin-bottom: 8px;}
		:deep(.btn){padding: 0 15px; height: 40px; font-size: 12px; margin: 0 5px 5px 0;}
		:deep(ul){
			list-style: none; padding: 0; margin: 0 0 15px 10px;
			li{
				position: relative; padding: 0 0 4px 20px;
				&:before{.pseudo(8px,8px); background: var(--blue2); border-radius: 100px; left: 0; top: 8px;}
			}
		}
		:deep(.list-special){margin: 0!important;}
	}
	.newwindow{
		display: block; margin-top: 8px; font-size: 12px; padding-left: 20px; margin-bottom: 16px;
	}
</style>